module.exports = __webpack_public_path__ + "static/media/UNICOM.0398d136.svg";